import {Action} from "@ngrx/store";
import {CloudflareData} from "../../websites/website/booster/mappers/cloudflare/cloudflare-data";
import {DefaultRecord} from "../../websites/website/booster/mappers/cloudflare/default-record";

export const LOAD_CLOUDFLARE_DATA: string = '[redirect] Load Cloudflare Data';
export const SET_ENTERPRISE_CDN_DISABLED: string = '[redirect] Set Enterprise CDN Disabled';
export const SET_FULL_PAGE_CACHE_DISABLED: string = '[redirect] Set Full Page Cache Disabled';
export const SET_ORIGINAL_RECORD_VALUE: string = '[redirect] Set original record value';
export const SET_SETTINGS_VALUES: string = '[redirect] Set settings value';
export const LOAD_CLOUDFLARE_DATA_SUCCESS: string = '[redirect] Load Cloudflare Data Success';
export const LOAD_CLOUDFLARE_DATA_FAIL: string = '[redirect] Load Cloudflare Data Fail';
export const LOAD_CLOUDFLARE_DEFAULT_RECORD: string = '[redirect] Load Cloudflare Default Record';
export const LOAD_CLOUDFLARE_DEFAULT_RECORD_SUCCESS: string = '[redirect] Load Cloudflare Default Record Success';
export const LOAD_CLOUDFLARE_DEFAULT_RECORD_FAIL: string = '[redirect] Load Cloudflare Default Record Fail';

export class LoadCloudflareData implements Action {
  readonly type: string = LOAD_CLOUDFLARE_DATA;
  constructor(public payload: number) {}
}

export class LoadCloudflareDataSuccess implements Action {

  readonly type: string = LOAD_CLOUDFLARE_DATA_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    entities: CloudflareData,
  }) {}

}

export class LoadCloudflareDataFail implements Action {

  readonly type: string = LOAD_CLOUDFLARE_DATA_FAIL;
  constructor(public payload: string) {}

}


export class LoadCloudflareDefaultRecord implements Action {
  readonly type: string = LOAD_CLOUDFLARE_DEFAULT_RECORD;
  constructor(public payload: number) {}
}

export class LoadCloudflareDefaultRecordSuccess implements Action {

  readonly type: string = LOAD_CLOUDFLARE_DEFAULT_RECORD_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    dnsRecords: DefaultRecord,
  }) {}

}

export class LoadCloudflareDefaultRecordFail implements Action {

  readonly type: string = LOAD_CLOUDFLARE_DEFAULT_RECORD_FAIL;
  constructor(public payload: string) {}

}

export class SetToggleEnterPriceCDNDisabled implements Action {

  readonly type: string = SET_ENTERPRISE_CDN_DISABLED;
  constructor(public payload: {
    websiteId: number,
    cdnDisabled: boolean,
  }) {}

}

export class SetClodFlareOriginalRecord implements Action {

  readonly type: string = SET_ORIGINAL_RECORD_VALUE;
  constructor(public payload: {
    websiteId: number,
    originalRecord: string
  }) {}

}

export class SetSettingsValues implements Action {

  readonly type: string = SET_SETTINGS_VALUES;
  constructor(public payload: {
    websiteId: number,
    settingsValues: any,
  }) {}

}

export class SetFullPageCacheDisabled implements Action {

  readonly type: string = SET_FULL_PAGE_CACHE_DISABLED;
  constructor(public payload: {
    websiteId: number,
    fullPageCacheDisabled: boolean
  }) {}

}


export type CloudflareDataAction = LoadCloudflareData | LoadCloudflareDataSuccess | LoadCloudflareDataFail
  | LoadCloudflareDefaultRecord | LoadCloudflareDefaultRecordSuccess | LoadCloudflareDefaultRecordFail | SetToggleEnterPriceCDNDisabled | SetFullPageCacheDisabled | SetClodFlareOriginalRecord | SetSettingsValues;
